import create, { SetState, StateCreator, StoreApi } from "zustand";

interface IChronicBreakdownStore {
  clearStore: () => void;
  chronicName: any;
  setChronicName: (x: any) => void;
  selectedProvider: any;
  setSelectedProvider: (x: any) => void;
  selectedHealthPlan: any;
  setSelectedHealthPlan: (x: any) => void;
  selectedPCPVendor: any;
  setSelectedPcpVendor: (x: any) => void;
  patientIds: any;
  patientIdsHandler: (x: any) => void;
  comingFromChronicBreakdown: boolean;
  memberPageNavigationHandler: (x: boolean) => void;
  options: any;
  setOptions: (x: any) => void;
  selectedYear: any;
  setSelectedYear: (x: any) => void;
  selectedCity: any;
  setSelectedCity: (x: any) => void;
  selectedState: any;
  setSelectedState: (x: any) => void;
  selectedChronicCondition: any;
  setSelectedChronicCondition: (x: any) => void;
  pcpVendorOptions: any;
  setPcpVendorOptions: (x: any) => void;
  healthPlanOptions: any;
  setHealthPlanOptions: (x: any) => void;
  cityOptions: any;
  setCityOptions: (x: any) => void;
  stateOptions: any;
  setStateOptions: (x: any) => void;
  yearOptions: any;
  setYearOptions: (x: any) => void;
  chronicConditionOptions: any;
  setChronicConditionOptions: (x: any) => void;
  appliedProvider: any;
  setAppliedProvider: (x: any) => void;
  chartData: any;
  setChartData: (x: any) => void;
  chartLoading: boolean;
  setChartLoading: (x: boolean) => void;
  loadingState: boolean;
  setLoadingState: (loading: boolean) => void;
  loadingCity: boolean;
  setLoadingCity: (loading: boolean) => void;
  loadingHealthPlan: boolean;
  setLoadingHealthPlan: (loading: boolean) => void;
  loadingPcpVendor: boolean;
  setLoadingPcpVendor: (loading: boolean) => void;
  loadingProviders: boolean;
  setLoadingProviders: (loading: boolean) => void;
  loadingChronicCondition: boolean;
  setLoadingChronicCondition: (loading: boolean) => void;
}

let store: StateCreator<IChronicBreakdownStore, [], [], IChronicBreakdownStore> | StoreApi<IChronicBreakdownStore> = (set: SetState<IChronicBreakdownStore>) => ({
  chronicName: null,
  setChronicName: (x) => {
    set(() => ({ chronicName: x }));
  },
  selectedProvider: [],
  setSelectedProvider: (x) => {
    set(() => ({ selectedProvider: x }));
  },
  selectedHealthPlan: [],
  setSelectedHealthPlan: (x) => {
    set(() => ({ selectedHealthPlan: x }));
  },
  selectedPCPVendor: [],
  setSelectedPcpVendor: (x) => {
    set(() => ({ selectedPCPVendor: x }));
  },
  options: [],
  setOptions: (x) => {
    set(() => ({ options: x }));
  },
  selectedYear: [],
  setSelectedYear: (x) => {
    set(() => ({ selectedYear: x }));
  },
  selectedCity: [],
  setSelectedCity: (x) => {
    set(() => ({ selectedCity: x }));
  },
  selectedState: [],
  setSelectedState: (x) => {
    set(() => ({ selectedState: x }));
  },
  selectedChronicCondition: [],
  setSelectedChronicCondition: (x) => {
    set(() => ({ selectedChronicCondition: x }));
  },
  pcpVendorOptions: [],
  setPcpVendorOptions: (x) => {
    set(() => ({ pcpVendorOptions: x }));
  },
  healthPlanOptions: [],
  setHealthPlanOptions: (x) => {
    set(() => ({ healthPlanOptions: x }));
  },
  patientIds: [],
  patientIdsHandler: (x) => {
    set(() => ({ patientIds: x }));
  },
  comingFromChronicBreakdown: false,
  memberPageNavigationHandler: (x) => {
    set(() => ({ comingFromChronicBreakdown: x }));
  },
  appliedProvider: false,
  setAppliedProvider: (x) => {
    set(() => ({ appliedProvider: x }));
  },
  yearOptions: [],
  setYearOptions: (x) => {
    set(() => ({ yearOptions: x }));
  },
  cityOptions: [],
  setCityOptions: (x) => {
    set(() => ({ cityOptions: x }));
  },
  stateOptions: [],
  setStateOptions: (x) => {
    set(() => ({ stateOptions: x }));
  },
  chronicConditionOptions: [],
  setChronicConditionOptions: (x) => {
    set(() => ({ chronicConditionOptions: x }));
  },
  chartData: {},
  setChartData: (x) => {
    set(() => ({ chartData: x }));
  },
  chartLoading: false,
  setChartLoading: (x) => {
    set(() => ({ chartLoading: x }));
  },
  loadingState: false,
  setLoadingState: (loading: boolean) => set(() => ({ loadingState: loading })),
  loadingCity: false,
  setLoadingCity: (loading: boolean) => set(() => ({ loadingCity: loading })),
  loadingHealthPlan: false,
  setLoadingHealthPlan: (loading: boolean) => set(() => ({ loadingHealthPlan: loading })),
  loadingPcpVendor: false,
  setLoadingPcpVendor: (loading: boolean) => set(() => ({ loadingPcpVendor: loading })),
  loadingProviders: false,
  setLoadingProviders: (loading: boolean) => set(() => ({ loadingProviders: loading })),
  loadingChronicCondition: false,
  setLoadingChronicCondition: (loading: boolean) => set(() => ({ loadingChronicCondition: loading })),
  clearStore: () => {
    set(() => ({ selectedProvider: [] }));
    set(() => ({ selectedHealthPlan: [] }));
    set(() => ({ selectedPCPVendor: [] }));
    set(() => ({ patientIds: [] }));
    set(() => ({ comingFromChronicBreakdown: false }));
    set(() => ({ options: [] }));
    set(() => ({ pcpVendorOptions: [] }));
    set(() => ({ healthPlanOptions: [] }));
    set(() => ({ appliedProvider: [] }));
    set(() => ({ chronicName: null }));
    set(() => ({ chartData: {} }));
    set(() => ({ loadingState: false }));
    set(() => ({ loadingCity: false }));
    set(() => ({ loadingHealthPlan: false }));
    set(() => ({ loadingPcpVendor: false }));
    set(() => ({ loadingProviders: false }));
    set(() => ({ loadingChronicCondition: false }));
  },
});

export const useChronicBreakdownStore = create(store);